<template>
    <flex-element :element-type="elementType" class="f-inline-block" class-default-inline="f-w-4 f-h-4 f-bg-red-600" />
</template>

<script>
import baseOrganism from '@/mixins/base-organism/base-organism-smart';

export default {
    name: 'shape',
    mixins: [baseOrganism],

    props: {
        displayName: {
            type: String,
            default: 'Shape',
        },
    },

    data() {
        return {
            cssDisplay: 'inline-block',
        };
    },
};
</script>
